<template>
    <div v-if="have_data == false">
        <section class="section section-shaped section-md my-0 section-header-pages">
            <div class="shape shape-style-1 bg-gradient-default        shape-default--shape-skew">
                <span></span>
                <span></span>
                <span style="visibility:hidden"></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container shape-container d-flex">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-6 col-md-7">

                            <div class="d-flex  align-items-end" style="height: 100%;">
                                <div class="flex-column">
                                    <h3 class="mb-0 text-white">Inversión en Igualdad <br> y Género</h3>
                                    <h2 class="display-2 mb-0 text-white">{{ general.city }}</h2>
                                    <h5 class="mb-0 text-white"><span class="text-header-title">Gestión:</span> {{ year }}</h5>
                                    <h5 class="mb-0 text-white"><span class="text-header-title">Nivel:</span> {{ type }}</h5>
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-6 col-md-5">

                            <div class="d-flex justify-content-end box-img-region floating">
                                <div class="rounded shadow-lg-- overflow-hidden transform-perspective-right--">
                                    <img src="" class="" alt="">
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-md">
            <div class="container">
                <div class="row row-grid align-items-center--">
                    <div class="col-lg-12">
                        <div class="">
                            <h3><span class="fa fa-flash"></span> No existen datos para mostrar.</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <div v-else>
        <section class="section section-shaped section-md my-0 section-header-pages">
            <div class="shape shape-style-1 bg-gradient-default        shape-default--shape-skew">
                <span></span>
                <span></span>
                <span style="visibility:hidden"></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container shape-container d-flex">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-6 col-md-7">


                            <div class="d-flex  align-items-end" style="height: 100%;">
                                <div class="flex-column">
                                    <h3 class="mb-0 text-white">Inversión en Igualdad <br> y Género</h3>
                                    <h2 class="display-2 mb-0 text-white">{{ general.city }}</h2>
                                    <h5 class="mb-0 text-white"><span class="text-header-title">Gestión:</span> {{ year }}</h5>
                                    <h5 class="mb-0 text-white"><span class="text-header-title">Nivel:</span> {{ type }}</h5>
                                    <div class="btn-wrapper mt-4">
                                        <router-link :to="{ name: 'investment.municipalities.list', params: { year: this.$route.params.year, city: general.id } }" class="btn btn-white btn-border-radius btn-custom-nav text-capitalize">Ranking Municipal</router-link>
                                        <a href="javascript:;" class="btn btn-white btn-border-radius text-capitalize btn-custom-nav" @click="modals.modal2 = true">Mapa</a>

                                            <modal :show.sync="modals.modal2"
                                                   body-classes="p-0"
                                                   modal-classes="modal-dialog-centered modal-lg">
                                                   <template slot="header">
                                                      <h5 class="modal-title" id="exampleModalLabel">Mapa de {{ general.city }}</h5>
                                                   </template>
                                                <card type="secondary" shadow
                                                      header-classes="bg-white pb-5"
                                                      body-classes="px-lg-5 py-lg-5"
                                                      class="border-0 box-modal-img-map">

                                                    <img :src="this.backend_domain + '/uploads/cities/maps/' + general.image_map" class="" alt="">

                                                </card>

                                            </modal>

                                        <vue-bootstrap-typeahead
                                          v-model="query"
                                          placeholder="Buscar municipio..."
                                          :data="municipalities"
                                          :serializer="item => item.name"
                                          @hit="redirectToRegion($event)"
                                          class="custom-input mt-3"
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-6 col-md-5">

                            <div class="d-flex justify-content-end box-img-region floating">
                                <div class="rounded shadow-lg-- overflow-hidden transform-perspective-right--">
                                    <img :src="this.backend_domain + '/uploads/cities/logos/' + general.image_logo" class="" alt="">
                                </div>
                            </div>

                        </div>

                        <div class="col-12">
                          <div class="custom-bredcrumbs site-nav-wrap">
                             <nav class="nav">
                                <div class="single-breadcrumb-wrap">
                                  <span class="sep"><i class="fa fa-caret-right"></i></span> <span class="breadcrumb2">
                                    <router-link :to="{ name: 'investment.home' }">Inicio IIEG</router-link>
                                  </span>
                                </div>
                                <div class="single-breadcrumb-wrap">
                                  <span class="sep"><i class="fa fa-caret-right"></i></span> <span class="breadcrumb2">
                                    <router-link :to="{ name: 'investment.municipalities.national', params: { year: year, city: 0 } }">Bolivia</router-link>
                                  </span>
                                </div>
                                <div class="single-breadcrumb-wrap">
                                  <span class="sep"><i class="fa fa-caret-right"></i></span> <span class="breadcrumb2">
                                    <a href="javascript:;">{{ general.city }}</a>
                                  </span>
                                </div>
                            </nav>
                          </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>

        <section class="section section-md">
            <div class="container">
                <div class="row row-grid align-items-center--">
                    <div class="col-lg-6">
                        <div class="">

                            <loading :active.sync="isLoading.chart1" :is-full-page="false" :loader="'dots'" :color="'#51c3c8'"></loading>

                            <h4>A. Presupuesto de Inversión en IIEG</h4>
                            <p>Inversión en Igualdad y Equidad de Género IIEG</p>

                            <!--<div class="chartwrapper">
                                <div class="chartdiv" ref="chart1"></div>
                            </div>-->

                            <div class="custom-chart-container" ref="chart1"></div>

                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="">

                            <loading :active.sync="isLoading.chart2" :is-full-page="false" :loader="'dots'" :color="'#ec1c8d'"></loading>

                            <h4>B. Ranking Municipal en IIEG</h4>
                            <p>Porcentaje de participación de IIEG según rango de inversión</p>


                            <div class="custom-chart-container" ref="chart2"></div>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-md section-tabs-tables">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-12">
                        <div class="" style="min-height:300px">

                            <h4>C. Composición de la IIEG</h4>
                            <p>Composición del presupuesto destinado a la IIEG por categoría municipal y de análisis</p>

                            <tabs fill class="flex-column flex-md-row tables-margin">
                                <card shadow slot-scope="{activeTabIndex}" class="mt-3">
                                    <tab-pane key="tab1">
                                        <template slot="title">Según Categoría de Análisis</template>

                                        <div class="table-responsive box-table-custom">
                                            <loading :active.sync="isLoading.table1" :is-full-page="false" :loader="'dots'" :color="'#ec1c8d'" :opacity="1" ></loading>
                                            <table class="table table-striped table-bordered1">
                                              <thead>
                                                <tr>
                                                  <th scope="col" class="text-center">Categoría de Análisis</th>
                                                  <th scope="col" class="text-center">Denominación</th>
                                                  <th scope="col" class="text-center">Monto Ejecutado</th>
                                                  <th scope="col" class="text-center">% ejecución respecto al total inversión ejecutada</th>
                                                </tr>
                                              </thead>
                                              <tbody>

                                                <tr v-for="(item1, index) in tables.globalIIEG.data">
                                                  <th scope="row" >{{ item1.name }}</th>
                                                  <td class="">{{ item1.description }}</td>
                                                  <td class="text-right">{{ item1.value | decimal }}</td>
                                                  <td class="text-right">{{ item1.percent }} %</td>
                                                </tr>

                                              </tbody>
                                              <tfoot>
                                                  <tr>
                                                      <th scope="col" >{{ tables.globalIIEG.totals.name }}</th>
                                                      <th scope="col" class=""></th>
                                                      <th scope="col" class="text-right">{{ tables.globalIIEG.totals.value | decimal }}</th>
                                                      <th scope="col" class="text-right">{{ tables.globalIIEG.totals.percent }} %</th>
                                                  </tr>
                                              </tfoot>
                                            </table>
                                        </div>

                                    </tab-pane>

                                    <tab-pane key="tab2">
                                        <template slot="title">Según Categoría Municipal</template>

                                        <div class="table-responsive box-table-custom">
                                            <loading :active.sync="isLoading.table2" :is-full-page="false" :loader="'dots'" :color="'#ec1c8d'" :opacity="1" ></loading>

                                            <table class="table table-striped table-bordered1">
                                              <thead>
                                                <tr>
                                                  <th scope="col" class="text-center">Categoría</th>
                                                  <th scope="col" class="text-center" v-for="(i, index) in tables.categoryIIEG.categories">{{ i.category_name }}</th>
                                                  <th scope="col" class="text-center">Total IIEG</th>
                                                  <th scope="col" class="text-center">% ejecución respecto al total de inversión ejecutada</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr v-for="(item2, index) in tables.categoryIIEG.data">
                                                  <th scope="col">{{ item2.name }}</th>
                                                  <td scope="row" class="text-right" v-for="(k, index) in item2.iieg">
                                                    <span v-if="k.name === 'percent'">{{ k.value }} %</span>
                                                    <span v-else>{{ k.value | decimal }}</span>
                                                  </td>
                                                </tr>
                                              </tbody>
                                              <tfoot>
                                                  <tr>
                                                      <th scope="col">Total</th>
                                                      <th scope="col" class="text-right" v-for="(j, index) in tables.categoryIIEG.totals.iieg">
                                                        <span v-if="index == tables.categoryIIEG.totals.iieg.length - 1">{{ j }} %</span>
                                                        <span v-else>{{ j | decimal }}</span>
                                                      </th>
                                                  </tr>
                                              </tfoot>
                                            </table>

                                        </div>

                                    </tab-pane>

                                </card>
                            </tabs>



                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-md">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-12">
                        <div class="" style="min-height:300px">

                            <h4>D. Fuentes de Financiamiento</h4>
                            <p>Fuentes de Financiamiento de la IIEG</p>

                            <card shadow body-classes="" class="mt-5">
                                <div class="table-responsive box-table-custom">
                                    <loading :active.sync="isLoading.table3" :is-full-page="false" :loader="'dots'" :color="'#ec1c8d'" :opacity="1" ></loading>

                                    <table class="table table-striped table-bordered1">
                                      <thead>
                                        <tr>
                                          <th scope="col" class="text-center">Categoría</th>
                                          <th scope="col" class="text-center" v-for="(s, index) in tables.sourceFounding.sources">{{ s.source_name }}</th>
                                          <th scope="col" class="text-center">Total IIEG</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="(item3, index) in tables.sourceFounding.data">
                                          <th scope="col">{{ item3.name }}</th>
                                          <td scope="row" class="text-right" v-for="(nt, index) in item3.iieg">{{ nt.value | decimal }}</td>
                                        </tr>
                                      </tbody>
                                      <tfoot>
                                          <tr>
                                              <th scope="col">Total</th>
                                              <th scope="col" class="text-right" v-for="(p, index) in tables.sourceFounding.totals.iieg">{{ p | decimal }}</th>
                                          </tr>
                                      </tfoot>
                                    </table>

                                </div>
                            </card>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-md">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-12">
                        <div class="">

                            <loading :active.sync="isLoading.chart3" :is-full-page="false" :loader="'dots'" :color="'#51c3c8'"></loading>

                            <h4>E. Comparación por Categoría Municipal</h4>
                            <p>Comparación del presupuesto ejecutado en IIEG por categoría municipal</p>

                            <div class="custom-chart-container" ref="chart3"></div>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-md mb-5">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-12">
                        <div class="">

                            <h4>F. Indicador de Eficiencia de la IIEG</h4>
                            <p>Indicador de eficiencia de la inversión total frente a la IIEG</p>

                            <div class="row row-grid align-items-center mt-5">
                                <div class="col-md-5 text-center">
                                    <h1 class="display-1 mb-0 font-raleway font-weight-700" style="color: #873693">{{ tables.general.percent_iieg }} %</h1>
                                    <h6 class="mb-0">% de ejecuación</h6>
                                </div>
                                <div class="col-md-7">
                                    <div class="table-responsive box-table-custom">
                                        <loading :active.sync="isLoading.table4" :is-full-page="false" :loader="'dots'" :color="'#ec1c8d'" :opacity="1" ></loading>

                                        <table class="table table-striped table-bordered">
                                          <tbody>
                                            <tr>
                                              <th scope="row" >Presupuesto total de inversión programado</th>
                                              <td class="text-right">{{ tables.general.total_programmed | decimal }}</td>
                                              <th rowspan="2" scope="col" class="text-center">% de ejecución<br>{{ tables.general.percent }}%</th>
                                            </tr>
                                            <tr>
                                              <th scope="row" >Presupuesto total de inversión ejecutado</th>
                                              <td class="text-right">{{ tables.general.total_executed | decimal }}</td>

                                            </tr>
                                            <tr>
                                              <th scope="row" >Presupuesto total en IIEG programado</th>
                                              <td class="text-right">{{ tables.general.total_iieg_programmed | decimal }}</td>
                                              <th rowspan="2" scope="row" class="text-center">% de ejecución<br>{{ tables.general.percent_iieg }}%</th>
                                            </tr>
                                            <tr>
                                              <th scope="row" >Presupuesto total en IIEG ejecutado</th>
                                              <td class="text-right">{{ tables.general.total_iieg_executed | decimal }}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Modal Chart -->
        <modal :show.sync="modals.modal1">
            <h6 slot="header" class="modal-title" id="modal-title-default">Presupuesto Ejecutado IIEG</h6>
            <div>
                <loading :active.sync="isLoading.chart1_2" :is-full-page="false" :loader="'dots'" :color="'#51c3c8'"></loading>
                <div class="custom-chart-container" ref="chart1_2"></div>
            </div>

            <template slot="footer">
                <base-button type="link" class="ml-auto" @click="modals.modal1 = false">Salir
                </base-button>
            </template>
        </modal>
        <!-- End Modal Chart-->
    </div>
</template>

<script>
const axios = require('axios');

import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
import Modal from "@/components/Modal.vue";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);

import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';


export default {
  name: "region",
  data() {
    return {
        have_data: true,

        //spinner load
        isLoading: {
            chart1 : false,
            chart1_2 : false,
            chart2 : false,
            chart3 : false,
            table1 : false,
            table2 : false,
            table3 : false,
            table4 : false,
        },

        //charts instances
        charts: {},

        //tables data
        tables: {
            globalIIEG: { data: '', totals: '' },
            categoryIIEG: { data: '', totals: '', categories: '' },
            sourceFounding: { data: '', totals: '', sources: '' },
            general: '',
        },

        //general data
        general: '',
        year: '',
        type: '',

        // search
        query: '',
        municipalities: [],
        selectedItem: null,

        //modals
        modals: {
            modal1: false,
            modal2: false
        },

        //urls
        backend_domain: process.env.VUE_APP_API_DOMAIN,
    }
  },
  watch: {
    query(newQuery) {
        let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/municipalities/c/${this.$route.params.city}/query/${newQuery}`;
        axios.get(uri)
        .then((response) => {
          this.municipalities = response.data.items;
        })
    }
  },
  components: {
    VueBootstrapTypeahead,
    Modal,
    Tabs,
    TabPane,
    Loading
  },
  filters: {
    decimal(num) {
        var nStr = parseFloat(num).toFixed(0);
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;

        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    }
  },
  computed: {

  },
  methods: {

    getGeneralData(){

        let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/investments/y/${this.$route.params.year}/t/municipalities/c/${this.$route.params.city}/data`;

        axios.get(uri).then((response) => {

            console.log(response.data);
            if(response.data.success){
                this.general = response.data.result;
                this.year = response.data.year;
                this.type = response.data.type;
            } else {
                if(response.data.having_data == false) {
                    this.have_data = false;
                    this.general = response.data.result;
                    this.year = response.data.year;
                    this.type = response.data.type;
                } else {
                    this.$router.push({name: 'error404'});
                }
            }
        }).catch((response) => {
            console.log(response)
        }).finally(() => {

        });
    },
    getAsyncChartsTables() {
        this.chartPieInvestmentGlobal();
        this.chartPieRankingIIEG();
        this.chartPieInvestentIIEG();

        this.tableGlobalIIEG();
        this.tableCategoryIIEG();
        this.tableSourceFounding();

        this.chartBarCategoryPop();

        this.tableGeneralInvestments();
    },
    async chartPieInvestmentGlobal() {
        this.isLoading.chart1 = true;
        let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/investments/y/${this.$route.params.year}/t/municipalities/c/${this.$route.params.city}/chartInvGlobal`;
        await axios.get(uri).then((response) => {
            if(response.data.success) {
                this.renderChartPieInvestmentGlobal(response.data.chart);
            } else { console.log(response.data); }
        }).catch((response) => {
            console.log(response)
        }).finally(() => {
            this.isLoading.chart1 = false;
        });
    },
    renderChartPieInvestmentGlobal(data) {
      // console.log(data);
        var vm = this;
        let chart = am4core.create(this.$refs.chart1, am4charts.PieChart);
        chart.responsive.enabled = true;

        chart.hiddenState.properties.opacity = 0;
        chart.data = data;
        chart.innerRadius = am4core.percent(30);

        chart.legend = new am4charts.Legend();
        chart.legend.fontSize = 13;
        chart.legend.marginTop = 40;

        var series = chart.series.push(new am4charts.PieSeries());
        series.legendSettings.valueText = "[bold {color}]{value.percent.formatNumber('#.00')}%[/bold]";
        //series.labels.template.disabled = true;
        series.ticks.template.disabled = false;
        series.alignLabels = true;

        series.colors.list = [
          am4core.color("#873693"),
          am4core.color("#cc8b00")
        ];

        //series.dataFields.value = "value";
        series.dataFields.value = "percent";
        series.dataFields.depthValue = "slug"; //3d
        series.dataFields.category = "name";

        series.slices.template.propertyFields.isActive = "pulled";
        series.slices.template.tooltipText = "";
        series.slices.template.cornerRadius = 3;
        series.slices.template.stroke = am4core.color("#fff");
        series.slices.template.strokeWidth = 1;
        series.slices.template.strokeOpacity = 1;
        series.slices.template.cursorOverStyle = [{ "property": "cursor", "value": "pointer" }];

        series.labels.template.text = "{depthValue} {value.percent.formatNumber('#.00')}%";
        series.labels.template.wrap = true;
        series.labels.template.maxWidth = 80;
        series.labels.template.fontSize = 12;

        series.slices.template.events.on("hit", function(event) {
            if(event.target.dataItem.dataContext.name  == "Total ejecutado en IIEG"){
                vm.modals.modal1 = true
            }
        });
        vm.charts.chart1 = chart;
        //this.modals.modal1 = true;
    },
    async chartPieRankingIIEG() {
        this.isLoading.chart2 = true;
        let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/investments/y/${this.$route.params.year}/t/municipalities/c/${this.$route.params.city}/chartRankingIIEG`;
        await axios.get(uri).then((response) => {
            if(response.data.success) {
                this.renderChartPieRankingIIEG(response.data.chart);
            } else { console.log(response.data); }
        }).catch((response) => {
            console.log(response)
        }).finally(() => {
            this.isLoading.chart2 = false;
        });
    },
    renderChartPieRankingIIEG(data) {

        var vm = this;
        let chart = am4core.create(this.$refs.chart2, am4charts.PieChart);
        chart.responsive.enabled = true;

        chart.hiddenState.properties.opacity = 0;
        chart.data = data;
        chart.innerRadius = am4core.percent(30);
        chart.legend = new am4charts.Legend();
        chart.legend.fontSize = 13;
        chart.legend.marginTop = 40;

        var series = chart.series.push(new am4charts.PieSeries());
        series.legendSettings.valueText = "[bold {color}]{value.percent.formatNumber('#.00')}%[/bold]";
        series.ticks.template.disabled = false;
        series.alignLabels = true;

        series.colors.list = [
          am4core.color("#007bc2"),
          am4core.color("#a2c617"),
          am4core.color("#f8d74a"),
          am4core.color("#ff8005"),
          am4core.color("#ff0004"),
        ];

        series.dataFields.hidden = "hidden";
        series.dataFields.value = "value";
        series.dataFields.category = "name";

        series.slices.template.tooltipText = "";
        series.slices.template.cornerRadius = 3;
        series.slices.template.stroke = am4core.color("#fff");
        series.slices.template.strokeWidth = 1;
        series.slices.template.strokeOpacity = 1;

        series.labels.template.text = "{category} {value.percent.formatNumber('#.00')}%";
        series.labels.template.wrap = true;
        series.labels.template.maxWidth = 110;
        series.labels.template.fontSize = 12;

        vm.charts.chart2 = chart;
    },
    async chartPieInvestentIIEG() {
        this.isLoading.chart1_2 = true;
        let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/investments/y/${this.$route.params.year}/t/municipalities/c/${this.$route.params.city}/chartIIEG`;
        await axios.get(uri).then((response) => {
            if(response.data.success) {
                this.renderChartPieInvestentIIEG(response.data.chart);
            } else { console.log(response.data); }
        }).catch((response) => {
            console.log(response)
        }).finally(() => {
            this.isLoading.chart1_2 = false;
        });
    },
    renderChartPieInvestentIIEG(data) {

        var vm = this;
        let chart = am4core.create(this.$refs.chart1_2, am4charts.PieChart);
        chart.responsive.enabled = true;

        chart.hiddenState.properties.opacity = 0;
        chart.data = data;
        chart.innerRadius = am4core.percent(30);
        chart.legend = new am4charts.Legend();
        chart.legend.fontSize = 13;
        chart.legend.marginTop = 40;

        var series = chart.series.push(new am4charts.PieSeries());
        series.legendSettings.valueText = "[bold {color}]{value.percent.formatNumber('#.00')}%[/bold]";
        //series.ticks.template.disabled = true;
        //series.labels.template.disabled = true;
        //series.alignLabels = false;
        //series.labels.template.radius = am4core.percent(10);

        series.dataFields.value = "value";
        series.dataFields.category = "name";
        series.dataFields.hidden = "hidden";

        series.slices.template.tooltipText = "";
        series.slices.template.cornerRadius = 3;
        series.slices.template.stroke = am4core.color("#fff");
        series.slices.template.strokeWidth = 1;
        series.slices.template.strokeOpacity = 1;

        series.labels.template.text = "{category} {value.percent.formatNumber('#.00')}%";
        series.labels.template.wrap = true;
        series.labels.template.maxWidth = 100;
        series.labels.template.fontSize = 12;

        vm.charts.chart3 = chart;
    },
    async tableGlobalIIEG(){
        this.isLoading.table1 = true;
        let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/investments/y/${this.$route.params.year}/t/municipalities/c/${this.$route.params.city}/tableGlobalIIEG`;
        await axios.get(uri).then((response) => {
            if(response.data.success) {
                this.tables.globalIIEG.data = response.data.data;
                this.tables.globalIIEG.totals = response.data.totals[0];
            } else { console.log(response.data); }
        }).catch((response) => {
            console.log(response)
        }).finally(() => {
            this.isLoading.table1 = false;
        });
    },
    async tableCategoryIIEG(){
        this.isLoading.table2 = true;
        let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/investments/y/${this.$route.params.year}/t/municipalities/c/${this.$route.params.city}/tableCategoryIIEG`;
        await axios.get(uri).then((response) => {
            if(response.data.success) {
                this.tables.categoryIIEG.data = response.data.data;
                this.tables.categoryIIEG.totals = response.data.totals;
                this.tables.categoryIIEG.categories = response.data.categories;
            } else { console.log(response.data); }
        }).catch((response) => {
            console.log(response)
        }).finally(() => {
            this.isLoading.table2 = false;
        });
    },
    async tableSourceFounding() {
        this.isLoading.table3 = true;
        let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/investments/y/${this.$route.params.year}/t/municipalities/c/${this.$route.params.city}/tableSourceFounding`;
        await axios.get(uri).then((response) => {
            if(response.data.success) {
                this.tables.sourceFounding.data = response.data.data;
                this.tables.sourceFounding.totals = response.data.totals;
                this.tables.sourceFounding.sources = response.data.sources;
                console.log(this.tables.sourceFounding);
            } else { console.log(response.data); }
        }).catch((response) => {
            console.log(response)
        }).finally(() => {
            this.isLoading.table3 = false;
        });
    },
    async chartBarCategoryPop() {
        this.isLoading.chart3 = true;
        let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/investments/y/${this.$route.params.year}/t/municipalities/c/${this.$route.params.city}/chartBarCategory`;
        await axios.get(uri).then((response) => {
            if(response.data.success) {
                this.renderChartBarCategoryPop(response.data.chart);
            } else { console.log(response.data); }
        }).catch((response) => {
            console.log(response)
        }).finally(() => {
            this.isLoading.chart3 = false;
        });
    },
    renderChartBarCategoryPop(data) {


        var maxv = this.getMaxValueChartBar(data);

        var vm = this;
        let chart = am4core.create(this.$refs.chart3, am4charts.XYChart);
        //chart.paddingTop = 50;
        chart.data = data;

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "name"; //category
        categoryAxis.renderer.grid.template.disabled = true;
        categoryAxis.renderer.minGridDistance = 30;
        //categoryAxis.renderer.inside = true;
        //categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
        categoryAxis.renderer.labels.template.fontSize = 20;


        var  valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.grid.template.strokeDasharray = "4,4";
        valueAxis.renderer.labels.template.disabled = true;
        valueAxis.min = 0;
        valueAxis.max = maxv;
        valueAxis.strictMinMax = true;


        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "percent"; //investment
        series.dataFields.categoryX = "name"; //category
        series.name = "Porcentaje";
        series.clustered = false;
        //series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
        series.columns.template.fillOpacity = .8;

        var columnTemplate = series.columns.template;
        columnTemplate.width = 120;
        columnTemplate.column.cornerRadiusTopLeft = 5;
        columnTemplate.column.cornerRadiusTopRight = 5;
        columnTemplate.column.cornerRadiusBottomLeft = 5;
        columnTemplate.column.cornerRadiusBottomRight = 5;
        columnTemplate.adapter.add("fill", function (fill, target) {
            return am4core.color("#cc8b00");
        });
        columnTemplate.strokeOpacity = 0;
        //columnTemplate.propertyFields.fill = am4core.color("#a8b3b7");
        //columnTemplate.propertyFields.stroke = "color";

        var txtLabel = series.bullets.push(new am4charts.LabelBullet());
        txtLabel.label.text = "{valueY} %";

        //txtLabel.locationY = 0.5;
        //txtLabel.label.verticalCenter = "top";
        txtLabel.label.fill = am4core.color("#000000");

        txtLabel.label.hideOversized = false;
        txtLabel.label.truncate = false;
        txtLabel.label.horizontalCenter = "middle";
        txtLabel.dy = -15;

        this.charts.chart3 = chart;
    },
    async tableGeneralInvestments() {
        this.isLoading.table4 = true;
        let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/investments/y/${this.$route.params.year}/t/municipalities/c/${this.$route.params.city}/tableGlobalGeneral`;
        await axios.get(uri).then((response) => {
            if(response.data.success) {
                this.tables.general = response.data.data[0];
            } else { console.log(response.data); }
        }).catch((response) => {
            console.log(response)
        }).finally(() => {
            this.isLoading.table4 = false;
        });
    },
    redirectToRegion($e) {

        this.$router.push({name:'investment.region.single', params: {year:this.$route.params.year, type: 'municipios', code: $e.code, name: this.slugify($e.name) }})
    },
    slugify(text) {
      return text.toString().toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
    getMaxValueChartBar(data) {
        let vt = 0;
        var tmp = data;
        tmp.forEach( function(valor, indice, array) {
          if(valor.percent > vt){
            vt = valor.percent;
          }
        });
        let ca = parseInt(vt).toString().length;
        if (ca == 1) {
          vt = vt + 1;
        } else if (ca == 2) {
          vt = vt + 10;
        }
        return vt;
    }
  },
  beforeMount() {
    this.getGeneralData();
  },
  mounted() {
    this.getAsyncChartsTables();
  },
  beforeDestroy() {
    if (this.charts.chart1) {
      this.charts.chart1.dispose();
    }
  }
};
</script>

<style scoped>
.chartwrapper {
  position: relative;
  width: 100%;
  height: 400px;
  background-color: green;
  border: 1px solid #333;
}
.chartdiv {
  position: absolute;
  top: -30px;
  left: -30px;
  width: 150%;
  height: 360px;
  background-color: red;
  border: 1px solid #999;
}
.custom-chart-container {
  width: 100%;
  height: 400px;
  margin-top: 60px;
}
</style>